<template>
  <LoaderView/>
  <h2 v-for="(title,index) in this.titles" :key="index" class="title" :class="title + '-title'">
    <template v-if="title === 'references'">
      <template v-if="this.lang === 'fr'">
        Références
      </template>
      <template v-else>
        {{title}}
      </template>
    </template>
    <template v-else>
      {{ title }}
    </template>
  </h2>

  <section class="section_projet">
    <Splide :options="splideOption" aria-label="Projets de Phase 5" :extensions="extensions">
      <SplideSlide v-for="(projet,index) in this.projets" :key="index" class="projet">
        <h4>{{ projet.title }}</h4>
        <img :src="projet.images[0].url">
        <router-link :to="`/projet/${projet.slug}`"></router-link>
      </SplideSlide>
    </Splide>
    <div class="go-down" v-on:click="goDown">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" viewBox="0 0 56.83 29.23">
        <line stroke-linecap="round" stroke-width="3px" x1="55.02" y1="14.79" x2="1.81" y2="14.79"/>
        <line stroke-linecap="round" stroke-width="3px" class="cls-1" x1="16.52" y1="27.2" x2="1.81" y2="14.79"/>
        <line stroke-linecap="round" stroke-width="3px" class="cls-1" x1="16.52" y1="2.2" x2="1.81" y2="14.79"/>
      </svg>
    </div>
  </section>

  <section ref="office_section" class="office-section">
    <section class="panel first">
    </section>
      <section id="office" class="panel office">
        <div class="image">
        </div>
        <div class="text">
          <Skeletor v-if="$apollo.queries.homepage.loading" as="p"/>
          <template v-else>
            <p v-if="this.lang === 'fr'" >{{ homepage.officeText }}</p>
            <p v-else >{{ homepage.localizations[0].officeText }}</p>
          </template>
        </div>
      </section>
      <section class="panel portrait p-1">
        <div class="image">
        </div>
        <div class="text">
          <div>
            <h3>Gilles Rossier</h3>
            <h5 v-if="this.lang ==='fr'">Directeur des travaux diplômé</h5>
            <h5 v-else>Qualified works manager</h5>
          </div>
          <Skeletor v-if="$apollo.queries.homepage.loading" as="p"/>
          <template v-else>
            <p v-if="this.lang === 'fr'" >{{ homepage.portaitTexte }}</p>
            <p v-else >{{ homepage.localizations[0].portaitTexte }}</p>
          </template>
        </div>
      </section>
      <section class="panel portrait p-2">
        <div class="image">
        </div>
        <div class="text">
          <div>
            <h3>David Bonfanti</h3>
            <h5 v-if="this.lang ==='fr'">Directeur des travaux diplômé</h5>
            <h5 v-else>Qualified works manager</h5>
          </div>
          <Skeletor v-if="$apollo.queries.homepage.loading" as="p"/>
          <template v-else>
            <p v-if="this.lang === 'fr'" >{{ homepage.collaborateur_text }}</p>
            <p v-else >{{ homepage.localizations[0].collaborateur_text }}</p>
          </template>
        </div>
      </section>
  </section>

  <section id="services" class="services-section">
    <div ref="scrolling_group_1" class="scrolling-group">
      <template v-if="!$apollo.queries.services.loading">
          <template v-for="(service, index) in this.services" :key="index">
            <div :id="'x-'+service.id" class="title" :class="{outlined: index % 2 === 1}" @mouseenter="handleMouseEnterOnService" @mousemove="handleMouseEnterOnService" @mouseleave="handleMouseLeaveOnService" >
              <h3 v-if="this.lang === 'fr'">{{ service.title }}</h3>
              <h3 v-else>{{ service.localizations[0].title }}</h3>
            </div>
            <div class="dot"></div>
        </template>
      </template>
    </div>
    <div ref="scrolling_group_2" class="scrolling-group">
      <template v-if="!$apollo.queries.services.loading">
          <template v-for="(service, index) in reversedServices" :key="index">
            <div :id="'x-'+service.id" class="title" :class="{outlined: index % 2 === 0}" @mouseenter="handleMouseEnterOnService" @mousemove="handleMouseEnterOnService" @mouseleave="handleMouseLeaveOnService" >
              <h3 v-if="this.lang === 'fr'">{{ service.title }}</h3>
              <h3 v-else>{{ service.localizations[0].title }}</h3>
            </div>
            <div class="dot"></div>
        </template>
      </template>
    </div>

    <template v-if="!$apollo.queries.services.loading">
      <div v-for="(service, index) in this.services" :key="index" :id="service.id" class="floating-service">
        <!-- <img :src="service.image.url" loading="lazy"> -->
        <div v-if="this.lang === 'fr'">
          <h4>{{ service.title }}</h4>
          <div v-html="service.description.html"></div>
        </div>
        <div v-else>
          <h4>{{ service.localizations[0].title }}</h4>
          <div v-html="service.localizations[0].description.html"></div>
        </div>
      </div>
    </template>

  </section>

  <section id="references" class="references-section">
    <div ref="veilLeft" class="veil left"></div>
    <div ref="veilRight" class="veil right"></div>
    <div class="references-block">
      <template v-if="!$apollo.queries.homepage.loading">
        <a v-for="(img,index) in this.homepage.logos" :key="index" :href="img.link" target="_blank">
          <img class="logo" :src="img.url" loading="lazy" >
        </a>
      </template>
    </div>
  </section>
  <div class="testify"></div>

  <FooterLayout/>
</template>

<script>
import gql from 'graphql-tag';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
import FooterLayout from "../components/layout/FooterLayout.vue";
import LoaderView from "../components/LoaderView.vue";
import { mapState } from 'vuex';
import { Skeletor } from 'vue-skeletor';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.normalizeScroll({ allowNestedScroll: true });

export default {
  name: 'HomeView',
  components: {
    FooterLayout,
    LoaderView,
    Skeletor,
    Splide,
    SplideSlide,
},
  apollo: {
    projets: {
    query: gql`
      query projets {
        projets(first: 100, where: {isMainPage: true},locales: [fr,en]) {
          id
          title
          slug
          images {
            url
          }
        }
      }`,
    },
    homepage:{
    query: gql`query homepage {
        homepage(where: {id: "cltorhmluq7ef07w114sv0r8v" }, locales: [fr]) {
          id
          officeText
          portaitTexte
          collaborateur_text
          logos(locales:[en]) {
            id
            alt
            url
            link
          }
          localizations{
            officeText
            portaitTexte
            collaborateur_text
          }
        }
      }`,
    },
    services:{
      query: gql`
        query services {
          services(locales: [fr,en]) {
            id
            title
            description {
              html
            }
            localizations{
              title
              description { html }
            }
          }
        }
      `,
    }
  },
  computed: {
    ...mapState([
      'lang',
      'documentReady'
    ]),
    reversedServices() {
      return [...this.services].reverse();
    },
  },
  data() {
    return {
      titles: [
        "projets",
        "office",
        "services",
        "references",
        "contact"
      ],
      projets : null,
      sections : null,
      officeHorizontalScroll: null,
      media : gsap.matchMedia(),
      gsapTimelines: [],
      splideOption: {
        type   : 'loop',
        fixedWidth : '15.625vw',
        fixedHeight : '15.625vw',
        arrows: false,
        pagination: false,
        breakpoints:{
          899:{
            fixedWidth : '250px',
            fixedHeight : '250px',
          },
        },
        autoScroll: {
          speed: 1,
          pauseOnHover: true
        },
      },
      extensions : {
        AutoScroll,
      }
    }
  },
  mounted(){
    if(this.documentReady){
      this.setupAllAnimation();

    }
  },
  methods:{
    handleMouseEnterOnService(e){
      const x = e.clientX;
      const y = e.clientY;
      const id = e.target.id.slice(2);
      const width = gsap.getProperty(`#${id}`,'width');

      this.media.add("(min-width: 900px)",()=>{
        gsap.to(`#${id}`,{
          autoAlpha:1,
          x:x-width /2,
          y:y-width /2
        });
      });
    },
    handleMouseLeaveOnService(e){
      const id = e.target.id.slice(2);

      this.media.add("(min-width: 900px)",()=>{
        gsap.to(`#${id}`,{
        autoAlpha:0,
        });
      });
    },
    setupHorizontalScroll() {
      const officeSection = this.$refs.office_section;
      this.sections = gsap.utils.toArray(officeSection.children);
      // Layout widths remain stable while GSAP transforms the panels.
      const scrollDistance = () => this.sections.reduce((width, panel) => width + panel.offsetWidth, 0)
        - officeSection.clientWidth;
      const horizontalScroll = gsap.to(this.sections, {
        x: () => -scrollDistance(),
        ease: "none",
        scrollTrigger: {
          trigger: officeSection,
          pin: true,
          scrub: 1,
          snap: false,
          end: () => "+=" + scrollDistance(),
          invalidateOnRefresh: true,
        }
      });
      this.officeHorizontalScroll = horizontalScroll;
      this.gsapTimelines.push(horizontalScroll);
    },
    setupOfficeTitlesAnimation() {
      this.media.add("(min-width: 900px)",()=>{
        const OfficeTitleAnimation = gsap.timeline({
        scrollTrigger:{
          trigger: ".office-section",
          scrub:1,
          start: "top+=200px bottom",
          end: () => this.officeHorizontalScroll.scrollTrigger.end,
          toggleActions: "play pause reset reset",
          preventOverlaps: true,
          fastScrollEnd:true,
        }})
        .to(".projets-title",{
          rotationX:'-90deg',
        },"0")
        .to(".office-title",{
          rotationX:'0deg',
        },"0.5")
        .to(".office-title",{
          x:"5vw",
        },"3")
        this.gsapTimelines.push(OfficeTitleAnimation);
      })

      this.media.add("(max-width: 899px)",()=>{
        const OfficeTitleAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".office-section",
            scrub:1,
            start: "top center",
            end:"top top",
            toggleActions: "play none none reverse",
            preventOverlaps: true,
            fastScrollEnd:true,
          },
        })
        .to(".projets-title",{
          y: "-24%",
          rotationX:'90deg',
        },"0")
        .to(".office-title",{
          rotationX:'0deg',
        },"1")
        this.gsapTimelines.push(OfficeTitleAnimation);
      })
    },
    setupServicesTitlesAnimation() {
      this.media.add("(min-width: 900px)",()=>{
        const ServicesTitleAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".services-section",
            start: "top-=10% bottom",
            end: "top top",
            scrub:1,
            toggleActions: "play none none reverse",
            preventOverlaps: true,
            fastScrollEnd:true,
          }
        })
        .to(".office-title",{
          rotationX:'90deg',
        },"0")
        .to(".services-title",{
          rotationX:'0deg',
        },"1")
        this.gsapTimelines.push(ServicesTitleAnimation);
      })

      this.media.add("(max-width: 899px)",()=>{
        const ServicesTitleAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".services-section",
            start: "top bottom",
            end: "top top+=20%",
            scrub:2,
            preventOverlaps: true,
            fastScrollEnd:true,
          }
        })
        .to(".office-title",{
          rotationX:'90deg',
        },"0")
        .to(".services-title",{
          rotationX:'0deg',
        },"1")
        .to(".services-title",{
          y:"-35svh"
        },"2")
        this.gsapTimelines.push(ServicesTitleAnimation);
      })

    },
    setupServicesAnimation() {
      this.media.add("(min-width: 900px)",()=>{
        const ServicesAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".services-section",
            start: "center+=10vw center-=15%",
            end: "bottom top",
            scrub:1,
            pin:true,
          }
        })
        .to(this.$refs.scrolling_group_1,{
          x:"-80%",
        },"0")
        .to(this.$refs.scrolling_group_2,{
          x:0,
        },"0");
        this.gsapTimelines.push(ServicesAnimation);
      })

      this.media.add("(max-width: 899px)",()=>{
        const ServicesAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".services-section",
            start: "top top+=25%",
            end: "bottom+=800% top",
            scrub:1,
            pin:true,
          }
        })
        .to([this.$refs.scrolling_group_1,this.$refs.scrolling_group_2],{
          autoAlpha:1
        },"appearing")
        .to(this.$refs.scrolling_group_1,{
          x:"-150%",
          duration:10
        },"appearing+=0.25")
        .to(this.$refs.scrolling_group_2,{
          x:0,
          duration:10
        },"appearing+=0.25")
        .to(".floating-service",{
          y:"-40%",
          stagger:2,
        },"appearing+=0.25");
        this.gsapTimelines.push(ServicesAnimation);
      });
    },
    setupReferencesAnimation() {
      this.media.add("(min-width: 900px)",()=>{
        const ReferencesAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".references-section",
            start: "top-=10% bottom",
            end: "top+=35% top",
            scrub:2,
            toggleActions: "play none none reverse",
            preventOverlaps: true,
            fastScrollEnd:true,
          }
        })
        .to(".services-title",{
          rotationX:'90deg',
        },"0")
        .to(".references-title",{
          rotationX:'0deg',
        },"3")
        .to([this.$refs.veilLeft,this.$refs.veilRight],{
          width:0,
        },"3")
        .to(".references-block img",{
          autoAlpha:1,
        },"4")
        .to(".references-block img",{
          autoAlpha:0,
        },"5");
        this.gsapTimelines.push(ReferencesAnimation);
      })

      this.media.add("(max-width: 899px)",()=>{
        const ReferencesAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".references-section",
            start: "top bottom",
            end: "bottom+=10% top",
            scrub:2,
            toggleActions: "play none none reverse",
            preventOverlaps: true,
            fastScrollEnd:true,
          }
        })
        .to(".services-title",{
          rotationX:'90deg',
        },"0")
        .to(".references-title",{
          rotationX:'0deg',
        },"1.5")
        .to([this.$refs.veilLeft,this.$refs.veilRight],{
          width:0,
        },">0.5")
        .to(".references-block img",{
          autoAlpha:1,
          stagger:1
        })
        .to(".references-block img",{
          autoAlpha:0,
          stagger:1
        });
        this.gsapTimelines.push(ReferencesAnimation);
      })
    },
    setupContactAnimation(){
      this.media.add("(min-width: 900px)",()=>{
        const ContactAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".testify",
            start: "top bottom-=20%",
            end: "top top",
            scrub:1,
            toggleActions: "play none none reverse",
            preventOverlaps: true,
            fastScrollEnd:true,
          }
        })
        .to(".references-title",{
          rotateX:'90deg',
        },"0")
        .to(".contact-title",{
          rotateX:0,
        },"1")
        this.gsapTimelines.push(ContactAnimation);
      })

      this.media.add("(max-width: 899px)",()=>{
        const ContactAnimation = gsap.timeline({
          scrollTrigger:{
            trigger: ".testify",
            start: "center center",
            end: "top top",
            scrub:1,
            toggleActions: "play none none reverse",
            preventOverlaps: true,
            fastScrollEnd:true,
          }
        })
        .to(".references-title",{
          rotateX:'90deg',
        },"0")
        .to(".contact-title",{
          rotateX:0,
        },"1")
        .to(".contact-title",{
          y:"-30vh",
        },"1");
        this.gsapTimelines.push(ContactAnimation);
      })
    },
    setupAllAnimation(){
      this.setupHorizontalScroll();
      this.setupOfficeTitlesAnimation();
      this.setupServicesTitlesAnimation();
      this.setupServicesAnimation();
      this.setupReferencesAnimation();
      this.setupContactAnimation();
      window.addEventListener("resize", this.refreshOnResize);
      ScrollTrigger.refresh();
    },
    cleanupAnimations() {
      this.media.revert();
      this.gsapTimelines.forEach(timeline => {
        if (timeline.scrollTrigger) {
          timeline.scrollTrigger.kill();
        }
        timeline.kill();
      });
      this.gsapTimelines = [];
      window.removeEventListener("resize", this.refreshOnResize);
    },
    refreshOnResize() {
      ScrollTrigger.refresh();
    },
    goDown() {
      window.scrollTo(0,document.querySelector(".office-section").getBoundingClientRect().top)
    }
  },
  beforeUnmount() {
    this.cleanupAnimations();
  },
  watch:{
    documentReady:{
      handler(documentReady){
        if(documentReady){
          this.setupAllAnimation();
        }
      }
    },
  }
}
</script>

<style lang="scss">
@import "../styles/includes.scss";
@import '@splidejs/vue-splide/css';
/*------PROJETS------*/

h2{
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 100%;
  font-size: clamp(54px, 13vw, 340px);
  margin: auto;
  z-index: 2;
  @include tablet{
    width: auto;
  }
  &.projets-title{
    top: 30%;
    @include tablet{
      top: 40%;
    }
  }
  &.office-title{
    transform: translateX(-50%) translateY(-150%) rotateX(-90deg);
    z-index: 8;
    @include tablet{
      transform: translateX(-50%) translateY(-108%) rotateX(-90deg);
      z-index: 2;
    }
  }
  &.services-title{
    transform: translateX(-50%) translateY(-108%) rotateX(90deg);
  }
  &.references-title{
    top: 15%;
    transform: translateX(-50%) rotateX(-90deg);
    z-index: 8;
    @include tablet{
      top: 25%;
      z-index: 2;
      width: 90%;
      transform: translateX(-50%) translateY(-25%) rotateX(-90deg);
    }
  }
  &.contact-title{
    transform: translateX(-50%) translateY(-50%) rotateX(-90deg);
    @include tablet{
      top:40%;
      transform: translateX(-50%) translateY(-109%) rotateX(-90deg);
    }
  }
}

.section_projet{
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  z-index: 5;
  height: calc(100dvh - var(--header-height));
}

.projet{
  position: relative;
  display: block;
  background-color: $white;
  transition: all 0.5s ease;
  contain: paint;
  aspect-ratio: 1/1;
  resize: horizontal;
  container-type: size;
  @include tablet{
    &:hover>h4{
      opacity: 1;
      transform: translateX(-50%) translateY(-50%);
      transition: 
        opacity 0.5s ease,
        transform 0.5s ease;
    }
    &:hover>img{
      transform: scale(1.2);
      transition: all 0.5s ease;
    }
  }
  &.is-active{
    h4{
      opacity: 1;
      transform: translateX(-50%) translateY(-50%);
      transition: 
        opacity 0.5s ease,
        transform 0.5s ease;
      }
      @include tablet{
        h4{
          opacity: 0;
          transform: translateX(-50%) translateY(-20%);
          transition: 
            opacity 0.5s ease,
            transform 0.5s ease;
        }
        &:hover h4{
          opacity: 1;
          transform: translateX(-50%) translateY(-50%);
          transition: 
            opacity 0.5s ease,
            transform 0.5s ease;
        }
      }
  }
  h4{
    opacity: 0;
    position:absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-20%);
    white-space: nowrap;
    z-index: 1;
    font-size: 16px;
    color: $black;
    transition: 
      opacity 0.5s ease,
      transform 0.5s ease;
      @include tablet{
        font-size: clamp(10px, 6cqw, 24px)
      }
  }
  & a{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  & img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    transition: all 0.5s ease;
    filter: grayscale(1) brightness(0.7)
  }

}

.go-down{
  display:flex;
  justify-content:center;
  align-items:center;
  margin-top: 3rem;
  padding: 1rem 0;
  border-top: 1px solid $black;
  cursor: pointer;
  svg{
    stroke: $black;
    transform: rotate(-90deg);
    transition: transform 0.25s linear;
  }
  &:hover{
    svg{
      filter: drop-shadow(0px 0px 10px $black);
      transform: rotate(-90deg) scale(1.1);
      transition: filter 0.25s linear;
    }
  }
}

/*------OFFICE------*/


.office-section {
  width: 100%;
  height: 100svh;
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  z-index: 5;

  > .panel {
    // Keep a full viewport per panel, regardless of the collaborator count.
    flex: 0 0 100%;
    min-width: 0;
    height: 100%;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: 45% minmax(0, 1fr);

    > .image {
      min-width: 0;
      min-height: 0;
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
    }

    > .text {
      min-width: 0;
      min-height: 0;
      width: 100%;
      padding: clamp(16px, 4vw, 48px);
      color: $black;

      // Keep long CMS copy accessible on short screens.
      > p {
        margin: 0;
        max-width: 65ch;
        font-size: clamp(16px, 1.3vw, 24px);
        line-height: 1.5;
        white-space: pre-line;
      }
    }

    &.office > .image {
      background-image: url("../assets/img/chantier-ensoleillé.jpg");
    }

    &.portrait {
      &.p-1 .image {
        background-image: url("../assets/img/Gilles-Rossier.jpg");
      }
      &.p-2 .image {
        background-image: url("../assets/img/David-Bonfanti.jpg");
      }
      @media (max-width: 374.98px) {
        > .text > p {
          font-size: 14px;
        }
      }
      > .text {
        display: flex;
        flex-direction: column;
        gap: clamp(16px, 3vh, 40px);

        > * {
          flex-shrink: 0;
        }
      }
    }
  }

  @media (orientation: landscape) {
    > .panel {
      grid-template-columns: minmax(0, 44fr) minmax(0, 56fr);
      grid-template-rows: minmax(0, 1fr);
      align-items: end;

      > .image {
        height: 80%;
      }
      > .text {
        max-height: 80%;
        padding: clamp(20px, 3vw, 64px);
      }
    }
  }

  @media (max-width: 899px) and (orientation: landscape) {
    > .panel > .image {
      height: 100%;
    }
    > .panel > .text {
      max-height: 100%;
    }
  }
}

/*------SERVICES------*/

.services-section{
  position: relative;
  padding-bottom: 30svh;
  z-index: 5;
  @include tablet{
    padding-bottom: 0;
    padding-top: 30vw;
  }
  @include tablet-portrait{
    padding-top: 60vh;
  }
  & .scrolling-group{
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 1.5vw;
    padding: 3vw 0;
    opacity: 0;
    visibility: hidden;
    @include tablet{
      opacity: 1;
      visibility: visible;
    }
    &>.title{
      height: 100%;
      & *{
          pointer-events: none;
      }
      & h3{
        font-size: clamp(20px, 4.4vw, 85px);
        white-space: nowrap;
        color: $black;
        mix-blend-mode: exclusion;
        @include tablet-portrait{
          font-size: clamp(30px, 4.2vw, 85px);
        }
      }
      &.outlined h3 {
        -webkit-text-stroke-width: clamp(1px, 0.2vw, 2px);
        -webkit-text-stroke-color: $black;
        color: transparent;
      }
    }
    &>.dot{
      display:flex;
      justify-content:center;
      align-items:center;
      height: 1vw;
      aspect-ratio: 1/1;
      border-radius: 50px;
      background-color: $black;
    }
  }
  & .scrolling-group:nth-child(1){
    transform: translateX(-0%);
  }
  & .scrolling-group:nth-child(2){
    transform: translateX(-80%);
  }
  & .floating-service{
        position:fixed;
        top: 95%;
        left: 0%;
        transform: translateY(250%);
        width: 100%;
        height: auto;
        padding-bottom: 2rem;
        box-sizing: border-box;
        background: $black;
        color: $white;
        contain: paint;
        pointer-events: none;
        @include tablet{
          top: 0%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          transform: inherit;
          gap: 5%;
          width: 60ch;
          height: auto;
          aspect-ratio: 1.6/1;
          clip-path: polygon(80% 100%, 100% 0%, 20% 0%, 0% 100%);
          box-sizing: content-box;
          padding: 3rem 8rem;
          opacity: 0;
          visibility: hidden;
        }
        &:before{
          content: "";
          position:absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 100%;
          height: 100%;
          background-color: $black;
          opacity: 0.5;
          z-index: 4;
          @include tablet{
            border-radius: 500px;
          }
        }
        &>img{
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 3;
          @include tablet{
            display: none;
          }
        }
        &>div{
          display: flex;
          flex-direction: column;
          margin-top: 2rem;
          gap: 1rem;
          @include smartphoneMini{
            margin-top: 2rem;
          }
          @include tablet{
            padding-left: 2rem;
            margin-top: 0;
            gap: 2rem;
          }
        }
        & h4{
          font-size: clamp(18px,1.5vw,35px);
          text-transform: uppercase;
          color: $white;
          z-index: 4;
          position: relative;
          margin: 0 5%;
          @include smartphoneMini{
            font-size: 16px;
          }
          @include tablet{
            margin: 0;
          }
        }
        & p{
          font-size: clamp(14px,4.2vw,22px);
          color: $white;
          text-align: justify;
          z-index: 4;
          position: relative;
          margin: 0 5%;
          padding-right: 2rem;
          @include tablet{
            margin: 0;
          }
        }
  }
}

/*------REFERENCES------*/

.references-section{
  position: relative;
  display:flex;
  justify-content:center;
  align-items:flex-end;
  min-height: 180svh;
  max-height: 1000px;
  margin-top: 70vh;
  contain: paint;
  background-color: $black;
  scroll-padding-top: 200vh;
  @include tablet{
    min-height: 140svh;
    align-items:center;
    max-height: 1300px;
    margin-top: 0;
  }
  & .veil{
    position:absolute;
    top: 0%;
    height: 100%;
    width: 50%;
    background-color: $white;
    z-index: -1;
    &.left{
      left: 0;
    }
    &.right{
      right: 0;
    }
  }
  & .references-block{
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    gap: 8vh;
    width: 55%;
    height: auto;
    margin-top: 25vw;
    font-size: clamp(40px,5vw,80px);
    color: $white;
    text-align: center;
    @include tablet{
      gap: 0;
      flex-flow: row wrap;
      justify-content: center;
      width: 85%;
      row-gap: 2rem;
      column-gap: 6rem;
    }
    & a {
      width: 70%;
      @include tablet{
        width: auto;
        flex: 0 1 12%;
      }
      &:hover img{
        mix-blend-mode: overlay;
      }
    }
    & img{
      width: 100%;
      opacity:0;
      visibility: hidden;
      filter: $filter-logo;
      @media (prefers-color-scheme: dark) {
        filter:$filter-logo;
      }
    }
  }
}

.testify{
  height: 40vh;
  padding-top:100svh;
  background-color: $black;
  @include tablet{
    padding-top:0;
  }
}
</style>
